/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  styled,
  SvgIconTypeMap,
  OutlinedInput,
  Stack
} from '@mui/material';
import { FC, useState } from 'react';
import { TSocialMedia } from 'src/models/general';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { IObjectInput } from 'src/models/objectManagement';
import useOnboarding from 'src/services/useOnboarding';
import GetSocialMediaIcon from '../GetSocialMediaIcon';
import TiktokIcon from '../TikTokIcon/TikTokIcon';
import { useLocation } from 'react-router';
import { isValidURL } from 'src/utils/isValidURL';
import { getSocmedFromDomain } from 'src/utils/getSocmedFromDomain';

interface ISocialMedia {
  id: TSocialMedia;
  label: string;
  icon:
    | (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string;
      })
    | any;
}

interface Props {
  onAdd: (tempObjectInput: IObjectInput) => void;
}

const CustomButton = styled(Button)(
  ({ theme }) => `
    border: unset;
      border-radius: 6px 0 0 6px;
      background-color: ${theme.palette.grey[200]};
      border: 1px solid ${theme.palette.divider};
      border-color: ${theme.palette.common.black}
      color: ${theme.palette.primary.main};
      &:hover{
        background-color: ${theme.palette.grey[300]};
      }

    `
);

const ListItemButtonCustom = styled(ListItemButton)(
  ({ theme }) => `
      &:hover {
        background-color: ${theme.palette.primary.light}
      }
    `
);

const listOptionSocialMedia: Array<ISocialMedia> = [
  {
    id: 'twitter',
    label: 'X',
    icon: TwitterIcon
  },
  {
    id: 'facebook',
    label: 'Facebook',
    icon: FacebookIcon
  },
  {
    id: 'instagram',
    label: 'Instagram',
    icon: InstagramIcon
  },
  {
    id: 'youtube',
    label: 'Youtube',
    icon: YouTubeIcon
  },
  {
    id: 'tiktok',
    label: 'Tiktok',
    icon: TiktokIcon
  }
];

const InputPostLink: FC<Props> = ({ onAdd }) => {
  const { pathname } = useLocation();
  const title = pathname.split('/')[2];
  const isEcommerce = title === 'ecommerce';

  const [socialMedia, setSocialMedia] = useState<TSocialMedia>(
    isEcommerce ? 'tokopedia' : 'twitter'
  );
  const [content, setContent] = useState<string>('');

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleChangeSocialMedia = (socialMediaId: TSocialMedia) => {
    setSocialMedia(socialMediaId);
    handleClose();
  };

  const { responseCreateObjects } = useOnboarding();

  const handleAdd = () => {
    const tempObjectInput: IObjectInput = {
      content: content,
      displayPic: '',
      excludes: [],
      extraContent: '',
      includes: [],
      isHashtag: false,
      languages: '',
      objectName: content,
      socialMedia: socialMedia,
      streamType: 'post_link'
    };
    onAdd(tempObjectInput);
    setContent('');
  };

  const handleChangeInputUrl = (url: string) => {
    setContent(url);
    if (isValidURL(url) && getSocmedFromDomain(url)) {
      setSocialMedia(getSocmedFromDomain(url));
    }
  };

  const handleClear = () => {
    setContent('');
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <CustomButton
          variant="contained"
          onClick={!content ? (event) => handleClick(event) : undefined}
          disabled={
            isValidURL(content) && Boolean(getSocmedFromDomain(content))
          }
        >
          <GetSocialMediaIcon socialMedia={socialMedia} color="primary" />
          <ArrowDropDownIcon fontSize="small" color="primary" sx={{ ml: 1 }} />
        </CustomButton>
        <OutlinedInput
          fullWidth
          placeholder={'Enter your post URL here'}
          onChange={(event) => handleChangeInputUrl(event.target.value)}
          value={content}
          sx={{
            borderRadius: 0
          }}
        />
      </Box>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        justifyContent="end"
        sx={{ py: 1 }}
      >
        <Button variant="outlined" onClick={handleClear}>
          Clear
        </Button>
        <Button
          variant="contained"
          disabled={!content || responseCreateObjects.loading}
          onClick={handleAdd}
        >
          + Add Post Link
        </Button>
      </Stack>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <List>
          {listOptionSocialMedia.map((socialMedia) => (
            <ListItem disablePadding key={socialMedia.id}>
              <ListItemButtonCustom
                onClick={() => handleChangeSocialMedia(socialMedia.id)}
              >
                <ListItemIcon>{<socialMedia.icon />}</ListItemIcon>
                <ListItemText primary={socialMedia.label} />
              </ListItemButtonCustom>
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default InputPostLink;
